
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { ToastrModule } from 'ngx-toastr';
import { NgChartsModule } from 'ng2-charts';
// import Chart from 'chart.js/auto';
// import { ChartModule } from 'ng2-charts';  // Import the ChartModule

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbGlobalPhysicalPosition,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { NgxEchartsModule } from 'ngx-echarts';
import { AppKeycloakService as KCS } from './services/keycloak.service';
import { KeycloakComponent } from './components/keycloak/keycloak.component';
// import { FetchSuppliersComponent } from './fetch-suppliers/fetch-suppliers.component';
// import { KeycloakAngularModule } from 'keycloak-angular';
// function initializeKeycloak(appKeycloak: KCS) {
//   return () => appKeycloak.initKeycloak();
// }
export function initializeKeycloak(kcs: KCS) {
  return () => kcs.init(); // Call your Keycloak init here
}
@NgModule({
  declarations: [AppComponent, KeycloakComponent,],
  schemas: [NO_ERRORS_SCHEMA],
  imports: [
    BrowserModule,  
    // ChartModule,
    //  KeycloakAngularModule,
    // KeycloakAngularModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    NgSelectModule,
    ScrollingModule,
    FormsModule,
    CommonModule,
    NgbModule,
    MatProgressBarModule,
    MatTabsModule,
    MatTableModule,
    NgChartsModule,
    NgbDatepickerModule,

    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(), 

    // NbToastrModule.forRoot(
    // {duration: 4000}),
    NbToastrModule.forRoot({
      duration: 4000, // duration of toast message in milliseconds
      position: NbGlobalPhysicalPosition.TOP_RIGHT, // position of the toast
      preventDuplicates: true, // Optional: Prevents duplicate messages
      hasIcon: true, // Optional: Show icon for each toast
      toastClass: 'custom-toast', // Custom class for your toast styling
      status: 'primary', 
  }),
    NbChatModule.forRoot({
      // messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    // ToastrModule.forRoot({
    //   closeButton: true
    // })
    ToastrModule.forRoot({
      closeButton: true, // Configure default options
      positionClass: 'toast-top-right', // Default position
      timeOut: 5000, // Default timeout
      progressBar: true // Show progress bar
    }),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
  ],
  providers: [
    AuthGuard, 
    AuthService,
    HttpClientModule,
    DatePipe,
    // { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    KCS,
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initializeKeycloak,
    //   multi: true,
    //   deps: [KCS],
    // },
    
   ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
